import React from "react";
import IconButton from "@material-ui/core/IconButton";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Popover from "@material-ui/core/Popover";
import SvgIcon from "@material-ui/core/SvgIcon";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import EmailOutlinedIcon from "@material-ui/icons/EmailOutlined";
import GavelOutlinedIcon from "@material-ui/icons/GavelOutlined";
import ImportContactsIcon from "@material-ui/icons/ImportContacts";
import PhoneAndroidOutlinedIcon from "@material-ui/icons/PhoneAndroidOutlined";
import PhoneOutlinedIcon from "@material-ui/icons/PhoneOutlined";
import PrintOutlinedIcon from "@material-ui/icons/PrintOutlined";
import RoomOutlinedIcon from "@material-ui/icons/RoomOutlined";
import { usePopupState, bindTrigger, bindMenu } from "material-ui-popup-state/hooks";
import * as Dati from "../../../Dati";

interface IContactInfoProps {
    DetailsJSON: string;
    AddressesJSON: string;
}

export const _ContactInfo: React.FC<IContactInfoProps> = ({ DetailsJSON, AddressesJSON }) => {
    const popupState = usePopupState({ variant: "popover", popupId: "details" });
    const details: Dati.CDatoRubrica[] = DetailsJSON ? JSON.parse(DetailsJSON) : [];
    const addresses: Dati.CDatoIndirizzo[] = AddressesJSON ? JSON.parse(AddressesJSON) : [];

    const GetDetailIcon = (type: number) => {
        switch (type) {
            case 1:
                return PhoneOutlinedIcon;
            case 2:
                return PhoneAndroidOutlinedIcon;
            case 3:
                return PrintOutlinedIcon;
            case 4:
                return EmailOutlinedIcon;
            case 5:
                return GavelOutlinedIcon;
        }
        return EditOutlinedIcon;
    };

    return (
        <>
            <IconButton aria-label="details" size="small" {...bindTrigger(popupState)}>
                <ImportContactsIcon />
            </IconButton>
            <Popover {...bindMenu(popupState)} getContentAnchorEl={null} anchorOrigin={{ vertical: "bottom", horizontal: "center" }} transformOrigin={{ vertical: "top", horizontal: "center" }}>
                <List dense>
                    {details.map(detail => (
                        <ListItem key={detail.ID_Tipologia}>
                            <ListItemIcon>
                                <SvgIcon component={GetDetailIcon(detail.ID_Tipologia)} fontSize="small" />
                            </ListItemIcon>
                            <ListItemText primary={detail.Valore} />
                        </ListItem>
                    ))}
                    {addresses.map((address, i) => (
                        <ListItem key={i}>
                            <ListItemIcon>
                                <RoomOutlinedIcon fontSize="small" />
                            </ListItemIcon>
                            <ListItemText primary={`${address.Indirizzo} - ${address.Cap} ${address.Citta} ${address.Provincia}`} />
                        </ListItem>
                    ))}
                </List>
            </Popover>
        </>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/components/ClientsList/ContactInfo.tsx